import React, { useEffect, useState } from 'react';
import { Card, message, Select, Spin } from 'antd';
import axios from 'axios';
import { Option } from 'antd/es/mentions';
import { useConfigQuery } from '../../../../queries/useConfig';
import { notification } from 'antd/lib';


const FormClientes = ({
  onClose,
  onSaved,
  cliente,
  setCliente
}) => {
  const { data: config, error } = useConfigQuery();
  const [cpfCnpj, setCpfCnpj] = useState('');
  const [nome, setNome] = useState('');
  const [email, setEmail] = useState('');
  const [telefone, setTelefone] = useState('');
  const [logradouro, setLogradouro] = useState('');
  const [numero, setNumero] = useState('');
  const [complemento, setComplemento] = useState('');
  const [cep, setCep] = useState('');
  const [bairro, setBairro] = useState('');
  const [documentoRgIE, setDocumentoRgIE] = useState('');
  const [cidades, setCidades] = useState([]);
  const [estados, setEstados] = useState([]);
  const [paises, setPaises] = useState([]);
  const [estadoSelecionado, setEstadoSelecionado] = useState();
  const [cidadeSelecionada, setCidadeSelecionada] = useState('');
  const [cpfCnpjMask, setCpfCnpjMask] = useState('cpf');
  const [codigoPais, setCodigoPais] = useState('55');



  const [isLoading, setIsLoading] = useState(false);

  const accessToken = window.localStorage.getItem("accessToken");
  const idUser = window.localStorage.getItem("idUser");
  const operador = window.localStorage.getItem('operador');

  const [consumidorJaCadastrado, setConsumirJaCadastrado] = useState(false);


  const [cidadeIBGE, setCidadeIBGE] = useState(null);

  const [novoCliente, setNovoCliente] = useState(true);


  useEffect(() => {
    if (accessToken && idUser) {
      const options = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + accessToken,
        },
      };

      axios
        .get(
          'https://techspdv-api-d3e739785e34.herokuapp.com/v1/paises',
          options,
        )
        .then(paises => {
          const comboPaises = paises.data._embedded.paises.map(pais => ({
            label: `${pais.codigo} - ${pais.nome}`,
            value: `${pais.codigo}`,
          }));

          setPaises(comboPaises);
        });
    }
  }, [idUser, accessToken]);
  useEffect(() => {
    if (accessToken && idUser) {
      const options = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + accessToken,
        },
      };

      const response2 = axios
        .get(
          'https://techspdv-api-d3e739785e34.herokuapp.com/v1/estados',
          options,
        )
        .then(estados => {
          const comboEstados = estados.data._embedded.estados.map(estado => ({
            label: `${estado.nome} - ${estado.uf}`,
            value: estado.cuf,
          }));

          setEstados(comboEstados);
        });
    }
  }, [idUser, accessToken]);

  useEffect(() => {
    if (accessToken && idUser && estadoSelecionado) {
      console.log(estadoSelecionado);
      setCidades([]);
      setCidadeSelecionada(null);
      // setEstadoSelecionado(estadoSelecionado);
      const options = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + accessToken,
        },
      };
      console.log(
        `https://techspdv-api-d3e739785e34.herokuapp.com/v1/cidades/listarPorEstadoCuf/${estadoSelecionado}`,
      );
      const response3 = axios
        .get(
          `https://techspdv-api-d3e739785e34.herokuapp.com/v1/cidades/listarPorEstadoCuf/${estadoSelecionado}`,
          options,
        )
        .then(cidades => {
          const comboCidades = cidades.data._embedded.cidades.map(cidade => ({
            label: `${cidade.nome}`,
            value: cidade.id,
          }));
          console.log('cidades.data');
          console.log(cidades.data._embedded.cidades);
          setCidades(comboCidades);

          if (cliente?.endereco?.cidade?.id) {
            setCidadeSelecionada(cliente.endereco.cidade.id);
          }
          setIsLoading(false);
        });
    }
  }, [idUser, accessToken, estadoSelecionado]);


  useEffect(() => {
    if (cliente == true) {
    } else {
      if (cliente) {
        setTelefone(cliente.telefone.replace(/^55/, ''));
        setCpfCnpj(cliente.documentoCpfCnpj);
        setNome(cliente.nomeCompleto);
        setEmail(cliente.email);


        let telefoneLimpo = cliente.telefone ? cliente.telefone.replace(/\D/g, '') : '';
        telefoneLimpo = telefoneLimpo.replace(/^55/, '');

        handleTelefoneChange(telefoneLimpo);
        if (cliente.endereco) {
          setLogradouro(cliente.endereco.logradouro);
          setNumero(cliente.endereco.numero);
          setComplemento(cliente.endereco.complemento);
          setBairro(cliente.endereco.bairro);
          setDocumentoRgIE(cliente.documentoRgIE);
          setCep(cliente.endereco.cep);
          setCidadeSelecionada(cliente.endereco.cidade.ibge);
          setEstadoSelecionado(cliente.endereco.cidade.cuf);
        }
      }
    }
  }, [cliente]);



  useEffect(() => {
    if (accessToken && idUser && estadoSelecionado) {
      setCidades([]);
      setCidadeSelecionada(null);

      const options = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + accessToken,
        },
      };

      axios
        .get(
          `https://techspdv-api-d3e739785e34.herokuapp.com/v1/cidades/listarPorEstadoCuf/${estadoSelecionado}`,
          options,
        )
        .then(response => {
          const comboCidades = response.data._embedded.cidades.map(cidade => ({
            label: cidade.nome,
            value: cidade.ibge,
            id: cidade.id,
          }));

          setCidades(comboCidades);

          // ✅ Tenta aplicar cidade se cidadeIBGE estiver presente
          if (cidadeIBGE) {
            const cidadeCorrespondente = comboCidades.find(c => c.value === cidadeIBGE);
            if (cidadeCorrespondente) {
              setCidadeSelecionada(cidadeCorrespondente.value);
            } else {
              console.warn('Cidade não encontrada na lista carregada:', cidadeIBGE);
            }
            setCidadeIBGE(null); // Limpa após usar
          }

          setIsLoading(false);
        });
    }
  }, [idUser, accessToken, estadoSelecionado, cidadeIBGE]);














  const buscarConsumidor = () => {
    if (!cpfCnpj) return;
    if (validarDocumento(cpfCnpj)) {
      const numericText = cpfCnpj.replace(/\D/g, '');
      setIsCnpj(numericText.length > 11);
      if (accessToken) {
        setIsLoading(true);
        const options = {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + accessToken,
          },
        };

        axios
          .get(
            `https://techspdv-api-d3e739785e34.herokuapp.com/v1/clientes/loja/${config?.idLoja}/cpfcnpj/${cpfCnpj}`,
            options,
          )
          .then(clienteResp => {
            if (clienteResp) {
              if (clienteResp.data) {
                setConsumirJaCadastrado(true);
                setCliente(clienteResp.data);
                setNovoCliente(false);
                setIsLoading(false);
              } else {
                setCliente(false);
                setIsLoading(false);
              }
            } else {
              setIsLoading(false);
            }

          }).catch(error => {
            console.error('Erro ao buscar consumidor:', error);
          })
      }
      return;
    }
  };

  const salvarConsumidor = () => {
    setIsLoading(true);
    const cidadeSelecionadaAux = cidades.find(
      cidade => cidade.value === cidadeSelecionada,
    );
    const options = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + accessToken,
      },
    };

    const consumidorForm = {
      ativo: true,
      documentoCpfCnpj: cpfCnpj,
      documentoRgIE: documentoRgIE,
      email: email,
      endereco: {
        bairro: bairro,
        cep: cep,
        cidade: {
          id: cidadeSelecionadaAux.id || '',
        },
        complemento: complemento,
        logradouro: logradouro,
        numero: numero,
      },
      nomeCompleto: nome,
      telefone: limparStringNumerica(`${codigoPais}${telefone}`),
      dataCadastro: cliente.dataCadastro,
    };
    if (cliente?.id) {
      axios
        .put(
          `https://techspdv-api-d3e739785e34.herokuapp.com/v1/clientes/loja/${config?.idLoja}/${cliente.id}`,
          //`http://localhost:8077/v1/clientes/loja/${config?.idLoja}/${cliente.id}`,
          consumidorForm,
          options,
        )
        .then(response => {
          console.log('Resposta:', response.data);
          notification.success({
            message: 'Sucesso',
            description: 'Cliente salvo!!',
          });
          onSaved?.(response.data);
          setIsLoading(false);
          onClose();
          return;
        })
        .catch(error => {
          notification.success({
            message: 'Erro',
            description: error.response?.data?.detail ? error.response.data.detail : error.response?.data?.error ? error.response?.data?.error : 'Falha na atualização!!',
          });
          setIsLoading(false);
          console.error('Erro:', error);
        });
    } else {
      axios
        .post(
          `https://techspdv-api-d3e739785e34.herokuapp.com/v1/clientes/loja/${config?.idLoja}`,
          consumidorForm,
          options,
        )
        .then(response => {
          notification.success({
            message: 'Sucesso',
            description: 'Cliente cadastrado!!',
          });
          onClose();
        })
        .catch(error => {
          notification.success({
            message: 'Erro',
            description: error.response?.data?.detail ? error.response.data.detail : error.response?.data?.error ? error.response?.data?.error : 'Falha no cadastro!!',
          });
          setIsLoading(false);
          console.error('Erro:', error);
        });
    }
  };

  const limparDados = () => {
    setNome('');
    setEmail('');
    setTelefone('');
    setDocumentoRgIE('');
    setCep('');
    setBairro('');
    setLogradouro('');
    setNumero('');
  };
  function validarDocumento(documento) {
    // Remover caracteres não numéricos
    documento = documento.replace(/[^\d]+/g, '');

    // Verificar se o documento é um CPF
    if (documento.length === 11) {
      let cpf = documento;
      let add = 0;
      for (let i = 0; i < 9; i++) {
        add += parseInt(cpf.charAt(i)) * (10 - i);
      }
      let rev = 11 - (add % 11);
      if (rev === 10 || rev === 11) rev = 0;
      if (rev !== parseInt(cpf.charAt(9))) return false;

      add = 0;
      for (let i = 0; i < 10; i++) {
        add += parseInt(cpf.charAt(i)) * (11 - i);
      }
      rev = 11 - (add % 11);
      if (rev === 10 || rev === 11) rev = 0;
      if (rev !== parseInt(cpf.charAt(10))) return false;

      return true;
    }

    // Verificar se o documento é um CNPJ
    else if (documento.length === 14) {
      let cnpj = documento;
      let tamanho = cnpj.length - 2;
      let numeros = cnpj.substring(0, tamanho);
      let digitos = cnpj.substring(tamanho);
      let soma = 0;
      let pos = tamanho - 7;
      for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2) pos = 9;
      }
      let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
      if (resultado !== parseInt(digitos.charAt(0))) return false;

      tamanho = tamanho + 1;
      numeros = cnpj.substring(0, tamanho);
      soma = 0;
      pos = tamanho - 7;
      for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2) pos = 9;
      }
      resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
      if (resultado !== parseInt(digitos.charAt(1))) return false;

      return true;
    }

    // Se não for nem CPF nem CNPJ, retorna false
    else {
      return false;
    }
  }

  const isTelefoneValido = (numero) => {
    const numeroLimpo = numero.replace(/\D/g, '');
    return (
      (numeroLimpo.length === 10 && /^(\d{2})(\d{4})(\d{4})$/.test(numeroLimpo)) ||
      (numeroLimpo.length === 11 && /^(\d{2})(\d{5})(\d{4})$/.test(numeroLimpo))
    );
  };


  useEffect(() => {
    if (cep.length === 8) {
      buscarEnderecoPorCep();
    }
  }, [cep]);


  useEffect(() => {
    if (cidadeIBGE && cidades.length > 0) {
      const cidadeEncontrada = cidades.find((c) => c.value === cidadeIBGE);
      if (cidadeEncontrada) {
        setCidadeSelecionada(cidadeEncontrada.value);
      } else {
        console.warn("Cidade não encontrada:", cidadeIBGE);
      }
      setCidadeIBGE(null); // Limpa após usar
    }
  }, [cidades, cidadeIBGE]);

  const buscarEnderecoPorCep = async () => {
    if (consumidorJaCadastrado) {

      setTimeout(() => {
        setCidadeSelecionada(cliente.endereco.cidade.ibge);
      }, 1000);
      return;
    }
    setIsLoading(true);
    try {
      const response = await axios.get(`https://viacep.com.br/ws/${cep}/json/`);
      const { data } = response;

      setBairro(data.bairro);
      setLogradouro(data.logradouro);

      if (data.ibge?.length === 7) {
        setEstadoSelecionado(data.ibge.substring(0, 2));
        setCidadeIBGE(data.ibge); // correto agora
      }
    } catch (error) {
      console.error("Erro ao buscar endereço:", error);
    } finally {
      setIsLoading(false);
    }
  };




  const onChangeCpfCnpj = text => {
    setCpfCnpj(text);

    // Remove caracteres não numéricos
    const numericText = text.replace(/\D/g, '');

    // Detecta se é CPF (11 dígitos) ou CNPJ (14 dígitos)
    if (numericText.length === 11) {
      setCpfCnpjMask('cpf');
    } else if (numericText.length === 14) {
      setCpfCnpjMask('cnpj');
    }
  };

  const [isCnpj, setIsCnpj] = useState(false);

  const toggleMask = text => {
    const numericText = text.replace(/\D/g, '');

    setIsCnpj(numericText.length > 10);

    setCpfCnpj(numericText);
  };
  const validateEmail = email => {
    // Expressão regular para validar o formato do e-mail
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleEmailChange = text => {
    setEmail(text);
  };

  const handleEmailBlur = () => {
    if (email.trim() !== '' && !validateEmail(email)) {
      message('E-mail Inválido', 'Por favor, insira um e-mail válido.');
    }
  };

  const handleTelefoneChange = text => {
    // Remove todos os caracteres não numéricos
    const numeroTelefone = text.replace(/\D/g, '');

    // Formata o número de telefone conforme necessário
    let telefoneFormatado = '';
    if (numeroTelefone.length <= 10) {
      // Formatação para telefones fixos (DDD + 8 ou 9 dígitos)
      telefoneFormatado = numeroTelefone.replace(
        /^(\d{2})(\d{4})(\d{4})$/,
        '($1) $2-$3',
      );
    } else {
      // Formatação para telefones celulares (DDD + 9 dígitos)
      telefoneFormatado = numeroTelefone.replace(
        /^(\d{2})(\d{5})(\d{4})$/,
        '($1) $2-$3',
      );
    }

    setTelefone(telefoneFormatado);
  };

  function limparStringNumerica(string) {
    return string.replace(/[^0-9\s]/g, '');
  }







  return (
    <div style={styles.container}>
      <header style={styles.header}>
        <h1>{cliente.id ? `Editar Cliente` : `Criar Cliente`}</h1>
      </header>
      {isLoading ? <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 40, width: '100%' }}>
        <Spin
          spinning={isLoading || (!cidadeSelecionada && cep)}
          size="large"
        />
        <span style={{ marginTop: 16, fontSize: 14, color: '#666' }}>{'Carregando...'}</span>
      </div> :
        <div>
          <label style={styles.label}>CPF ou CNPJ</label>
          <input
            type="text"
            placeholder="Cpf/Cnpj"
            value={cpfCnpj}
            onChange={(e) => toggleMask(e.target.value)}
            disabled={cliente != true}
            style={styles.input}
          />


          {cliente != true && (
            <>
              <label style={styles.label}>E-mail</label>
              <input
                type="text"
                placeholder="email"
                value={email}
                onChange={(e) => handleEmailChange(e.target.value)}
                onBlur={handleEmailBlur}
                autoComplete="email"
                style={styles.input}
              />

              <label style={styles.label}>Telefone</label>
              <div style={{ display: "flex", gap: "10px", marginBottom: "12px" }}>
                <Select
                  value={codigoPais || undefined}
                  placeholder="Selecione o país"
                  onChange={(valor) => {
                    setCodigoPais(valor);
                  }}
                  style={{
                    width: 240,
                    borderRadius: 4,
                    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                  }}
                  dropdownStyle={{ borderRadius: 4 }}
                  size="middle"
                >
                  {paises.map((pais) => (
                    <Option key={pais.value} value={pais.value}>
                      {pais.label}
                    </Option>
                  ))}
                </Select>
                <input
                  type="tel"
                  placeholder="Telefone"
                  value={telefone}
                  onChange={(e) => handleTelefoneChange(e.target.value)}
                  style={styles.input}
                />
              </div>
              <label style={styles.label}>Nome</label>
              <input
                type="text"
                placeholder="Nome"
                value={nome}
                onChange={(e) => setNome(e.target.value)}
                style={styles.input}
              />

              <label style={styles.label}>RG ou IE</label>
              <input
                type="text"
                placeholder="Rg/Ie"
                value={documentoRgIE}
                onChange={(e) => setDocumentoRgIE(e.target.value)}
                style={styles.input}
              />
              <label style={styles.label}>Estado</label>
              <Select
                value={estadoSelecionado || undefined}
                placeholder="Selecione o estado"
                onChange={(valor) => {
                  setEstadoSelecionado(valor);
                  setCidadeSelecionada(''); // limpa cidade ao mudar estado
                }}
                style={{
                  width: 240,
                  borderRadius: 4,
                  // adicionar sombra sutil
                  boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                }}
                dropdownStyle={{
                  // estilo do menu suspenso
                  borderRadius: 4,
                }}
                // você pode usar "size='large'" / "size='small'" para alterar altura
                size="middle"
              >
                {estados.map((estado) => (
                  <Option key={estado.value} value={estado.value}>
                    {estado.label}
                  </Option>
                ))}
              </Select>
              <label style={styles.label}>Cep</label>
              <input
                type="text"
                placeholder="Cep"
                value={cep}
                onChange={(e) => setCep(e.target.value)}
                maxLength={8}
                style={styles.input}
              />



              <label style={styles.label}>Cidade</label>
              <Select
                value={cidadeSelecionada || undefined}
                placeholder={
                  estadoSelecionado
                    ? 'Selecione a cidade'
                    : 'Selecione o estado primeiro'
                }
                onChange={(valor) => {
                  setCidadeSelecionada(valor);
                }}
                disabled={!estadoSelecionado}
                style={{
                  width: 240,
                  borderRadius: 4,
                  boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                }}
                dropdownStyle={{ borderRadius: 4 }}
                size="middle"
              >
                {cidades.map((cidade) => (
                  <Option key={cidade.value} value={cidade.value}>
                    {cidade.label}
                  </Option>
                ))}
              </Select>


              <label style={styles.label}>Bairro</label>
              <input
                type="text"
                placeholder="Bairro"
                value={bairro}
                onChange={(e) => setBairro(e.target.value)}
                style={styles.input}
              />

              <label style={styles.label}>Logradouro</label>
              <input
                type="text"
                placeholder="Logradouro"
                value={logradouro}
                onChange={(e) => setLogradouro(e.target.value)}
                style={styles.input}
              />

              <label style={styles.label}>Número</label>
              <input
                type="text"
                placeholder="Numero"
                value={numero}
                onChange={(e) => setNumero(e.target.value)}
                style={styles.input}
              />

              <label style={styles.label}>Complemento</label>
              <input
                type="text"
                placeholder="Complemento"
                value={complemento}
                onChange={(e) => setComplemento(e.target.value)}
                style={styles.input}
              />
            </>
          )}
          <div style={styles.actions}>
            {cliente != true ? (
              <>
                <button onClick={limparDados} style={{ ...styles.button, ...styles.buttonRed }}>
                  Limpar Dados
                </button>
                <button onClick={salvarConsumidor} style={{
                  ...styles.button,
                  cursor: !cidadeSelecionada || !cpfCnpj || !nome || !estadoSelecionado || !cep || !cidadeSelecionada || !bairro || !logradouro || !numero ? "not-allowed" : "pointer",
                  opacity: !cidadeSelecionada || !cpfCnpj || !nome || !estadoSelecionado || !cep || !cidadeSelecionada || !bairro || !logradouro || !numero ? 0.6 : 1,
                }}
                  disabled={!cidadeSelecionada || !cpfCnpj || !nome || !estadoSelecionado || !cep || !cidadeSelecionada || !bairro || !logradouro || !numero}>
                  Salvar Cliente
                </button>

                <button
                  onClick={() => {
                    onClose();
                  }}
                  style={{ ...styles.button, ...styles.buttonRed }}
                >
                  Voltar
                </button>
              </>
            ) : (
              <>
                <button
                  onClick={cpfCnpj && buscarConsumidor}
                  disabled={isLoading}
                  style={{
                    ...styles.button,
                    ...(isLoading && styles.buttonDisabled),
                  }}
                >
                  Confirmar
                </button>
                <button
                  onClick={() => {
                    onClose();
                  }}
                  style={{ ...styles.button, ...styles.buttonRed }}
                >
                  Fechar
                </button>
              </>
            )}
          </div>
        </div>}
    </div >
  );


};
const styles = {
  container: {
    padding: "16px",
    maxWidth: "600px",
    margin: "0 auto",
    backgroundColor: "#f9f9f9",
    borderRadius: "8px",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
  },
  headerButton: {
    padding: "8px 12px",
    backgroundColor: "#ff5c5c",
    color: "white",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "14px",
  },
  label: {
    display: "block",
    marginBottom: "6px",
    fontWeight: "bold",
    fontSize: "14px",
    color: "#555",
  },
  input: {
    width: "100%",
    padding: "8px",
    marginBottom: "12px",
    border: "1px solid #ccc",
    borderRadius: "4px",
    fontSize: "14px",
    boxSizing: "border-box",
  },
  /*  button: {
      width: "100%",
      padding: "10px",
      margin: "6px 0",
      backgroundColor: "#000000",
      color: "white",
      border: "none",
      borderRadius: "4px",
      cursor: "pointer",
      fontSize: "16px",
    },*/

  /* actions: {
     display: "flex",
     flexWrap: "wrap",
     justifyContent: "space-between",
   },*/
  actionButton: {
    width: "48%",
    marginBottom: "8px",
    padding: "10px",
  },




  actions: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    gap: "10px", // espaço entre os botões
  },

  button: {
    flex: "1 1 calc(50% - 10px)", // ocupa 50% menos o gap
    minWidth: "150px",            // largura mínima
    padding: "12px",              // altura mais uniforme
    borderRadius: "6px",          // cantos levemente arredondados (mais quadrado que circular)
    border: "1px solid #000000",
    backgroundColor: "#000000",
    fontSize: "14px",
    fontWeight: "bold",
    color: "#ffffff",
  },

  buttonRed: {
    backgroundColor: "#ff5c5c",
    color: "#fff",
    border: "none",
  },

  buttonDisabled: {
    backgroundColor: "#ccc",
    cursor: "not-allowed",
  }





};


export default FormClientes;
